module.exports = __webpack_public_path__ + "static/img/bdql.aab8c2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/bdql.png
// module id = 4hvs
// module chunks = 1